export default __webpack_public_path__ + "static/media/paypal_logo.324c9bbd.png";